import dayjs from 'dayjs'
import { useEffect, useState } from 'react'

import { getLongLanguageCode, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { getAppLanguage, setAppLanguage } from '@/core/native/storage'
import { SupportedLanguage } from '@/types/config'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { i18n } = useTranslation()
  //設定されている言語を取得
  const currentLang = getLongLanguageCode(i18n.language)
  const [language, setLanguage] = useState<SupportedLanguage>(currentLang)
  useEffect(() => {
    getAppLanguage().then(value => {
      setLanguage(value ?? currentLang)
    })
  }, [])

  return {
    state: {
      language,
    },
    actions: {
      async onChangeLanguage(lang) {
        setLanguage(lang)
        const [shortLangCode] = lang.split('-')
        await setAppLanguage(lang)
        await i18n.changeLanguage(shortLangCode)
        // dayJSの言語情報を設定
        dayjs.locale(shortLangCode)
      },
    },
  }
})
